import { matchVersion } from '../../utils';
import __regexp from './__firefox-ios-regexp';
/** Detect Mozilla Firefox iOS Browser version */
export default function isFirefoxIOSVersion(operator, version) {
	return function (ua) {
		return matchVersion({
			ua: ua,
			version: version,
			operator: operator,
			regExp: __regexp,
			groupIndex: 1
		});
	};
}
